import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/widgets/repeater.module.scss';

const EmptyState = ({ emptyStateText }) => {
  return <p className={styles.empty}>{emptyStateText}</p>;
};

EmptyState.propTypes = {
  emptyStateText: PropTypes.string.isRequired
};

export default EmptyState;
